import styled from "styled-components";

export const Float = styled.div`
  position: fixed;
  bottom: 15px;
  right: 15px;
  z-index: 99999;
  display: flex;
`;
